export default "__VITE_ASSET__BO6Vilbj__"